// @flow
import React, { memo, useCallback } from 'react'
import type { InputHelpsType } from '../../Types/InputHelpType'
import Popover from '../../Components/Popover'

type RadioProps = {
  checked: boolean,
  enabled: boolean,
  id: string,
  label: string,
  name: string,
  onChange: (string) => void,
  textMode: boolean,
  value: string,
  inputHelps?: InputHelpsType
}

const Radio = ({ checked, label, inputHelps, value, enabled = true, id, name, textMode, onChange }: RadioProps) => {
  const handleOnChange = useCallback((event: SyntheticInputEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  })

  if (textMode) {
    return checked &&
      <span><strong>{value}</strong></span>
  }

  return (
    <div className='custom-control custom-radio'>
      <input
        checked={checked}
        className='custom-control-input'
        data-hj-whitelist
        id={id}
        name={name}
        onChange={handleOnChange}
        readOnly={!enabled}
        type='radio'
        value={value}
      />
      <label className="custom-control-label custom-control-label-sm radio-middle" htmlFor={id}>{label}</label>
      {inputHelps && value in inputHelps && (
        <>
          &nbsp;
          <Popover
            content={inputHelps[value].content}
            id={`discount-title-${name}-${value}`}
            title={inputHelps[value].title}
          />
        </>
      )}
    </div>
  )
}

export default memo(Radio)
